import { useQuery } from '@tanstack/react-query';
import apiClient from '@/api/client';

export interface TelegramLinkData {
  /** null when the chat has no Telegram id — then `accessible` is false too. */
  link: string | null;
  is_public: boolean;
  accessible: boolean;
  chat_id: number;
  message_id: number;
}

export const useTelegramLink = (chatId: number, messageId: number) => {
  return useQuery<TelegramLinkData>({
    queryKey: ['telegram-link', chatId, messageId],
    queryFn: async () => {
      const response = await apiClient.get(
        `/messages/${messageId}/telegram-link`,
        { params: { chat_id: chatId } }
      );
      return response.data;
    },
    staleTime: Infinity, // Links never change
    enabled: !!chatId && !!messageId && chatId > 0 && messageId > 0, // Don't fetch if invalid IDs
  });
};
